// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__7HOtD","ribbon-tag":"tag_ribbon-tag__UmVpf","by-udemy-tag":"tag_by-udemy-tag__U4pG5","rating":"tag_rating__8933f"};